export const logo = ['608 134', `
  <title>WHAKAARO</title>

`]
